// i18next-extract-mark-ns-start menu
import routesMap from '../../Routes';
import { shouldShowIfEnglish } from '../../../languages';

export const getServicesList = (t) => ([
  { text: t('Menu-méthode'), url: routesMap.HowItWorksPage.url },
  { text: t('Menu-couture'), url: routesMap.CoutureServicesPage.url },
  { text: t('Menu-maroquinerie'), url: routesMap.LeatherGoodsServicesPage.url },
  { text: t('Menu-broderie'), url: routesMap.EmbroideryServicesPage.url },
  { text: t('Menu-cordonnerie'), url: routesMap.ShoesServicesPage.url },
  { text: t('Nos prix'), url: routesMap.PricingsPage.url },
]);

export const getAboutList = (t) => [
  { text: t('Notre histoire'), url: routesMap.AboutPage.url },
  { text: t('Nos boutiques'), url: routesMap.Retail.url },
  { text: t('Nos événements'), url: routesMap.EventsPage.url },
  { text: t('Notre blog'), url: routesMap.LaRubrique.url },
].filter(({ url }) => shouldShowIfEnglish(url));
